export default __webpack_public_path__ + "static/media/n5.c6f8c1fa.svg";